import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import axios from "axios";
import reportWebVitals from "./reportWebVitals";
import { AppRouter } from "./router/AppRouter";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const baseURL = process.env.REACT_APP_API_URL;
axios.defaults.baseURL = baseURL;

const theme = createTheme({
  typography: {
    h1: {
      fontFamily: 'Ethnocentric',
    },
    h2: {
      fontFamily: 'Ethnocentric',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Provider store={store}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
